module.exports = __webpack_public_path__ + "static/media/usb.18e615ef.svg";